import { CreateEdgeCredentialResponse, EdgeCredentialListResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/edge/credentials` — as máquinas que rodam o Aeris na loja (F041).
 *
 * Não é `/team/…`: uma credencial de máquina não é um membro da equipe, e a
 * permissão que a governa (`edge.manage`) é outra. O prefixo é o mesmo das
 * rotas que o Edge chama porque é o mesmo assunto.
 */
/**
 * As máquinas que rodam o Aeris na loja (F041).
 *
 * `/edge/credentials` e não `/team/…`: uma credencial de máquina não é um
 * membro da equipe, e a permissão que a governa (`edge.manage`) é outra. O
 * prefixo é o mesmo das rotas que o Edge chama porque é o mesmo assunto.
 */
export const fetchEdgeCredentials = async (signal) => EdgeCredentialListResponse.parse(await request('/api/v1/edge/credentials', { signal }));
/**
 * Emite uma credencial, e devolve o token uma vez só.
 *
 * Quem chama tem que mostrá-lo na hora: não existe uma segunda requisição que
 * o peça de novo, por desenho — o banco guarda o hash.
 */
export const createEdgeCredential = async (input) => CreateEdgeCredentialResponse.parse(await request('/api/v1/edge/credentials', { method: 'POST', body: input }));
export const revokeEdgeCredential = async (id, reason) => EdgeCredentialListResponse.parse(await request(`/api/v1/edge/credentials/${id}/revoke`, {
    method: 'POST',
    body: { reason },
}));
//# sourceMappingURL=edge.js.map